import { ListColumn, ListDataColumn } from "../ListColumn";
import { MeddraListView } from "./MeddraListView";

export class SOCListView extends MeddraListView {

    constructor(items: any) {
        let itemsWithChecked = items;
        if (itemsWithChecked && itemsWithChecked.length>0) {
            itemsWithChecked = items.map((info: any) => ({checked: false, ...info}));
        }

        const itemFinderArrayColumns: ListColumn[] = [
            new ListColumn("Num", ListDataColumn.TEXT, "num"),
            new ListColumn("SOC Name", ListDataColumn.TEXT, "name"),
            new ListColumn("SOC Abbrev", ListDataColumn.TEXT, "abbreviation"),
            new ListColumn("SOC Code", ListDataColumn.TEXT, "code")
        ];
        const itemFinderTreeColumns: ListColumn[] = [
            new ListColumn("SOC Name", ListDataColumn.TEXT, "name"),
            new ListColumn("SOC Abbrev", ListDataColumn.TEXT, "abbreviation"),
            new ListColumn("SOC Code", ListDataColumn.TEXT, "code")
        ];

        super(itemsWithChecked,  itemFinderArrayColumns, itemFinderTreeColumns);   
    }

}